// ============================================================
//  direct-validator.js
//  Size Validator for custom-measurements.liquid
//  Works with: cm-option-group[data-cm-option="provide_now"]
//  Save button ID: cm-measurements-done-btn
//  Panel open state: .is-open class (not an attribute)
// ============================================================

(function () {
  'use strict';

  console.log("🔍 SIZE VALIDATOR STARTING...");

  // ─── Size constraints ────────────────────────────────────────────────────
  // maxDimension = max width for rectangles, max diameter for circles
  // maxLength    = max length for rectangles (ignored for circles)

  const sizeConstraints = {
    'single':     { maxDimension: 92,  maxLength: 200 },
    'double':     { maxDimension: 137, maxLength: 200 },
    'king':       { maxDimension: 153, maxLength: 200 },
    'super-king': { maxDimension: 183, maxLength: 200 }
  };

  // ─── Size display labels ─────────────────────────────────────────────────

  const sizeLabels = {
    'single':     'Single',
    'double':     'Double',
    'king':       'King',
    'super-king': 'Super-King'
  };

  // ─── State ───────────────────────────────────────────────────────────────

  window.validatorState = {
    initialized:      false,
    constraints:      sizeConstraints['single'],
    selectedSize:     'single',
    currentUnit:      'cm',
    isCircular:       false,
    dimensionInputs:  { width: null, length: null, diameter: null },
    saveButtonHooked: false,
    cartButtonHooked: false
  };

  // ─── Unit helpers ────────────────────────────────────────────────────────

  function toCurrentUnit(valueCm) {
    switch (window.validatorState.currentUnit) {
      case 'mm': return valueCm * 10;
      case 'in': return valueCm * 0.393701;
      default:   return valueCm;
    }
  }

  function toCm(value) {
    switch (window.validatorState.currentUnit) {
      case 'mm': return value / 10;
      case 'in': return value / 0.393701;
      default:   return value;
    }
  }

  function unitLabel() {
    return window.validatorState.currentUnit;
  }

  // ─── Size suggester ───────────────────────────────────────────────────────
  // Given a value in cm, returns the smallest standard size it fits into,
  // or null if it exceeds super-king entirely

  function suggestSize(valueCm) {
    const order = ['single', 'double', 'king', 'super-king'];
    for (const size of order) {
      if (valueCm <= sizeConstraints[size].maxDimension) return size;
    }
    return null;
  }

  // ─── Validation ──────────────────────────────────────────────────────────
  // showEmptyError controls whether a blank field shows "Please enter a
  // measurement". On blur and unit switch this is false — the empty-field
  // error should only appear when the customer tries to Save.

  function validateField(input, type, showEmptyError) {
    if (!input) return true;

    const raw = input.value.trim();

    if (!raw) {
      if (showEmptyError) {
        showError(input, 'Please enter a measurement');
        return false;
      }
      // Empty field, not a save attempt — clear any existing state and pass
      input.classList.remove('msv-input--error', 'msv-input--success');
      const tooltip = input.parentElement && input.parentElement.querySelector('.msv-error-tooltip');
      if (tooltip) tooltip.style.display = 'none';
      return true;
    }

    const val = parseFloat(raw);
    if (isNaN(val) || val <= 0) {
      showError(input, 'Please enter a valid positive number');
      return false;
    }

    const c         = window.validatorState.constraints;
    const size      = window.validatorState.selectedSize;
    const sizeLabel = sizeLabels[size];

    if (type === 'diameter' || type === 'width') {
      const max      = toCurrentUnit(c.maxDimension);
      const maxLabel = Math.round(max);
      const label    = type === 'diameter' ? 'Diameter' : 'Width';
      if (val > max) {
        const valueCm   = toCm(val);
        const suggested = suggestSize(valueCm);
        if (suggested) {
          showError(input, `${label} of ${Math.round(val)}${unitLabel()} exceeds the maximum width of ${maxLabel}${unitLabel()} for ${sizeLabel} size — please go back and select ${sizeLabels[suggested]} size`);
        } else {
          showError(input, `${label} of ${Math.round(val)}${unitLabel()} exceeds the maximum available width of ${Math.round(toCurrentUnit(183))}${unitLabel()} — please contact us for a bespoke quote`);
        }
        return false;
      }
    }

    if (type === 'length') {
      const max = toCurrentUnit(c.maxLength);
      if (val > max) {
        const maxRounded = Math.round(toCurrentUnit(200));
        showError(input, `Length of ${Math.round(val)}${unitLabel()} exceeds our maximum length of ${maxRounded}${unitLabel()} — please contact us for a bespoke quote`);
        return false;
      }
    }

    clearError(input);
    return true;
  }

  // Validates all active inputs and returns overall pass/fail.
  // onSave = true means empty fields will show the "Please enter a measurement" error.

  function validateAll(onSave) {
    const s = window.validatorState;
    if (s.isCircular) {
      return validateField(s.dimensionInputs.diameter, 'diameter', !!onSave);
    }
    const w = validateField(s.dimensionInputs.width,  'width',  !!onSave);
    const l = validateField(s.dimensionInputs.length, 'length', !!onSave);
    return w && l;
  }

  // ─── Error display ────────────────────────────────────────────────────────

  window.showError = function (input, message) {
    input.classList.add('msv-input--error');
    input.classList.remove('msv-input--success');

    let tooltip = input.parentElement.querySelector('.msv-error-tooltip');
    if (!tooltip) {
      tooltip = document.createElement('div');
      tooltip.className = 'msv-error-tooltip';
      input.parentElement.style.position = 'relative';
      input.parentElement.appendChild(tooltip);
    }

    // Clear previous content
    tooltip.innerHTML = '';

    // Message text
    const msgSpan = document.createElement('span');
    msgSpan.textContent = message;
    tooltip.appendChild(msgSpan);

    // Close button
    const closeBtn = document.createElement('button');
    closeBtn.textContent = '×';
    closeBtn.className = 'msv-error-close';
    closeBtn.setAttribute('type', 'button');
    closeBtn.setAttribute('aria-label', 'Dismiss');

    // Prevent the input losing focus when × is clicked — without this,
    // blur fires on the input, re-runs validateField, and re-shows the
    // tooltip immediately, forcing the customer to click × twice
    closeBtn.addEventListener('mousedown', function (e) {
      e.preventDefault();
    });

    closeBtn.addEventListener('click', function () {
      tooltip.style.display = 'none';
      input.classList.remove('msv-input--error');
    });

    tooltip.appendChild(closeBtn);

    tooltip.style.display = 'flex';
    console.log(`🔍 ERROR: ${message}`);
  };

  window.clearError = function (input) {
    if (!input) return;
    input.classList.remove('msv-input--error');
    input.classList.add('msv-input--success');
    const tooltip = input.parentElement && input.parentElement.querySelector('.msv-error-tooltip');
    if (tooltip) tooltip.style.display = 'none';
  };

  // ─── Input event wiring ───────────────────────────────────────────────────

  function wireInput(input, type) {
    if (!input || input._validatorWired) return;
    input._validatorWired = true;

    let timer;

    // Validate 600ms after the user stops typing
    input.addEventListener('input', function () {
      clearTimeout(timer);
      if (this.value.trim() === '') {
        // Field cleared — remove all state, no error shown
        this.classList.remove('msv-input--error', 'msv-input--success');
        const tooltip = this.parentElement.querySelector('.msv-error-tooltip');
        if (tooltip) tooltip.style.display = 'none';
        return;
      }
      timer = setTimeout(() => validateField(this, type, false), 600);
    });

    // Validate on blur only if the field has a value — empty blur is ignored
    // so customers who accidentally click into a field don't get an error
    input.addEventListener('blur', function () {
      clearTimeout(timer);
      if (this.value.trim() === '') return;
      validateField(this, type, false);
    });

    // Deliberately NOT clearing errors on focus — the error must stay
    // visible so the customer knows what to correct

    console.log(`🔍 Wired ${type} input`);
  }

  // ─── Save Measurements intercept (primary gate) ───────────────────────────
  // Uses the exact ID from custom-measurements.liquid: cm-measurements-done-btn
  // Runs in capture phase so it fires BEFORE the existing fadeOut handler

  function interceptSaveButton() {
    if (window.validatorState.saveButtonHooked) return;

    const saveBtn = document.getElementById('cm-measurements-done-btn');
    if (!saveBtn) {
      console.warn("🔍 Save Measurements button not found (cm-measurements-done-btn)");
      return;
    }

    // onSave = true — empty fields will show "Please enter a measurement"
    saveBtn.addEventListener('click', function (e) {
      const allValid = validateAll(true);
      if (!allValid) {
        e.preventDefault();
        e.stopImmediatePropagation(); // stops the fadeOut/summary handler firing
        console.log("🚫 SAVE BLOCKED — validation failed");
      }
    }, true); // true = capture phase

    window.validatorState.saveButtonHooked = true;
    console.log("✅ Save Measurements button intercepted (cm-measurements-done-btn)");
  }

  // ─── Add to Cart intercept (secondary gate / belt-and-braces) ────────────

  function interceptCartButton() {
    if (window.validatorState.cartButtonHooked) return;

    const cartBtn = document.querySelector('[name="add"], .product-form__submit, #AddToCart');
    if (!cartBtn) {
      console.warn("🔍 Add to Cart button not found");
      return;
    }

    // onSave = true — treat the same as clicking Save
    cartBtn.addEventListener('click', function (e) {
      // Only apply when the customer has the "Enter Measurements" panel open
      const panel = document.querySelector('.cm-option-group[data-cm-option="provide_now"]');
      if (!panel || !panel.classList.contains('is-open')) return;

      const allValid = validateAll(true);
      if (!allValid) {
        e.preventDefault();
        e.stopImmediatePropagation();
        console.log("🚫 CART BLOCKED — validation failed");
      }
    }, true);

    window.validatorState.cartButtonHooked = true;
    console.log("✅ Add to Cart button intercepted");
  }

  // ─── Unit toggle ──────────────────────────────────────────────────────────

  function getCurrentUnit() {
    const active = document.querySelector('.cm-unit-btn.active');
    if (active) return (active.getAttribute('data-unit') || active.textContent.trim()).toLowerCase();
    return 'cm';
  }

  function watchUnitButtons() {
    document.querySelectorAll('.cm-unit-btn').forEach(btn => {
      btn.addEventListener('click', function () {
        setTimeout(() => {
          window.validatorState.currentUnit = getCurrentUnit();
          console.log("🔍 Unit changed to:", window.validatorState.currentUnit);

          // Only re-validate fields that already have a value — switching unit
          // must never trigger errors on empty fields
          const s = window.validatorState;
          if (s.isCircular) {
            if (s.dimensionInputs.diameter && s.dimensionInputs.diameter.value.trim() !== '') {
              validateField(s.dimensionInputs.diameter, 'diameter', false);
            }
          } else {
            if (s.dimensionInputs.width && s.dimensionInputs.width.value.trim() !== '') {
              validateField(s.dimensionInputs.width, 'width', false);
            }
            if (s.dimensionInputs.length && s.dimensionInputs.length.value.trim() !== '') {
              validateField(s.dimensionInputs.length, 'length', false);
            }
          }
        }, 100);
      });
    });
  }

  // ─── Size detection ───────────────────────────────────────────────────────

  function detectSize() {
    const url = window.location.href.toLowerCase();
    if (url.includes('super-king') || url.includes('6ft'))  return 'super-king';
    if (url.includes('king')       || url.includes('5ft'))  return 'king';
    if (url.includes('double')     || url.includes('4ft'))  return 'double';
    if (url.includes('single')     || url.includes('3ft'))  return 'single';

    const title = document.querySelector('h1, .product__title');
    if (title) {
      const t = title.textContent.toLowerCase();
      if (t.includes('super king')) return 'super-king';
      if (t.includes('king'))       return 'king';
      if (t.includes('double'))     return 'double';
      if (t.includes('single'))     return 'single';
    }

    // Safest fallback is single — it has the tightest constraints,
    // so it will block oversized entries rather than silently pass them
    console.warn("⚠️ Could not detect mattress size — defaulting to single (strictest)");
    return 'single';
  }

  function updateSize(size) {
    if (!sizeConstraints[size]) return;
    window.validatorState.selectedSize = size;
    window.validatorState.constraints  = sizeConstraints[size];
    console.log(`🔍 Size set to: ${size}`, window.validatorState.constraints);
  }

  // ─── Shape detection ─────────────────────────────────────────────────────
  // 1 input  = circular (diameter only)
  // 2 inputs = rectangular (width + length)
  // Falls back to aria-label / placeholder check for edge cases

  function detectShape(inputs) {
    if (inputs.length === 1) return 'circular';

    const label = (
      inputs[0].getAttribute('placeholder') ||
      inputs[0].getAttribute('aria-label')  ||
      ''
    ).toLowerCase();

    if (/diameter|dimension a/.test(label)) return 'circular';

    return 'rectangular';
  }

  // ─── Reset button integration ─────────────────────────────────────────────

  function setupResetButton() {
    const resetBtn = document.querySelector('.cm-reset-btn');
    if (!resetBtn) return;
    resetBtn.addEventListener('click', function () {
      const inputs = document.querySelectorAll('.cm-custom-input');
      inputs.forEach(input => {
        input.classList.remove('msv-input--error', 'msv-input--success');
        const tooltip = input.parentElement && input.parentElement.querySelector('.msv-error-tooltip');
        if (tooltip) tooltip.style.display = 'none';
      });
      console.log("🔍 Reset — all errors cleared");
    });
  }

  // ─── Main initialisation ──────────────────────────────────────────────────

  function initializeValidator() {
    console.log("🔍 Initialising validator...");

    const panel = document.querySelector('.cm-option-group[data-cm-option="provide_now"]');
    if (!panel) {
      console.log("🔍 Panel not found, retrying...");
      setTimeout(initializeValidator, 1000);
      return;
    }

    const inputs = Array.from(panel.querySelectorAll('.cm-custom-input'));
    console.log(`🔍 Found ${inputs.length} input(s)`);

    if (inputs.length === 0) {
      console.log("🔍 No inputs yet, retrying...");
      setTimeout(initializeValidator, 1000);
      return;
    }

    // Detect shape
    const shape = detectShape(inputs);
    window.validatorState.isCircular = (shape === 'circular');
    console.log("🔍 Shape:", shape);

    // Wire inputs
    if (window.validatorState.isCircular) {
      window.validatorState.dimensionInputs.diameter = inputs[0];
      wireInput(inputs[0], 'diameter');
    } else {
      window.validatorState.dimensionInputs.width  = inputs[0];
      window.validatorState.dimensionInputs.length = inputs[1] || null;
      wireInput(inputs[0], 'width');
      if (inputs[1]) wireInput(inputs[1], 'length');
    }

    // Sync unit, size, buttons
    window.validatorState.currentUnit = getCurrentUnit();
    updateSize(detectSize());
    watchUnitButtons();
    setupResetButton();
    interceptSaveButton();
    interceptCartButton();

    window.validatorState.initialized = true;
    console.log(`✅ VALIDATOR READY — shape: ${shape} | size: ${window.validatorState.selectedSize} | unit: ${window.validatorState.currentUnit}`);
  }

  // ─── Panel watcher ────────────────────────────────────────────────────────
  // Watches for .is-open being added or removed — matches exactly what
  // custom-measurements.liquid does when the customer opens/closes the panel

  function watchForPanel() {
    const panel = document.querySelector('.cm-option-group[data-cm-option="provide_now"]');

    if (!panel) {
      setTimeout(watchForPanel, 1000);
      return;
    }

    const observer = new MutationObserver(function () {
      if (panel.classList.contains('is-open')) {
        if (!window.validatorState.initialized) {
          console.log("🔍 Panel is-open detected — initialising");
          setTimeout(initializeValidator, 200);
        }
      } else {
        // Panel closed — reset so the validator re-initialises cleanly on reopen
        if (window.validatorState.initialized) {
          console.log("🔍 Panel closed — resetting validator state");
          window.validatorState.initialized      = false;
          window.validatorState.saveButtonHooked = false;
          window.validatorState.cartButtonHooked = false;
          window.validatorState.dimensionInputs  = { width: null, length: null, diameter: null };
        }
      }
    });

    // Watch for class attribute changes
    observer.observe(panel, { attributes: true, attributeFilter: ['class'] });

    // Already open on page load
    if (panel.classList.contains('is-open')) {
      console.log("🔍 Panel already open — initialising immediately");
      setTimeout(initializeValidator, 200);
    }

    console.log("🔍 Panel watcher active");
  }

  // ─── Boot ─────────────────────────────────────────────────────────────────

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchForPanel);
  } else {
    watchForPanel();
  }

  // Backstop — catches edge cases where panel is already open on load
  // and the MutationObserver missed it
  setTimeout(function () {
    if (!window.validatorState.initialized) {
      console.log("🔍 Backstop firing — attempting initialisation");
      initializeValidator();
    }
  }, 3000);

})();
